'use client'

import { useEffect } from 'react'
// oxlint-disable-next-line no-restricted-imports -- grandfathered; audit before touching (stuck branches can be load-bearing)
import { useMediaQuery } from 'react-responsive'
import { usePathname } from 'next/navigation'

import AccordionSimple from '@/components/accordion/AccordionSimple'

function FAQs({ data }) {
  const pathname = usePathname()
  const hash = typeof window !== 'undefined' ? window.location.hash : ''
  const isMobileSize = useMediaQuery({ maxWidth: 1200 })

  useEffect(() => {
    if (!hash) return

    const id = hash.replace('#', '')
    const element = document.getElementById(id)

    if (!element) return

    const timer = setTimeout(() => {
      const yOffset = isMobileSize ? -200 : -280
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset
      window.scrollTo({ top: y, behavior: 'smooth' })
    }, 300)

    return () => clearTimeout(timer)
  }, [pathname])

  return (
    <section className="section about container" data-aos="fade-up" data-aos-delay="200">
      <div className="d-flex mb-md-5 py-md-4 justify-content-center align-text-center">
        <h2 id="faq-title" className="heading">
          Frequently-asked questions (FAQ)
        </h2>
      </div>
      <div className="col-xl-10 mx-auto">
        <AccordionSimple
          data={data?.faqData}
          faqSchema
          toggleButton={true}
          viewAllButton={data?.faqData?.length > 8}
        />
      </div>
    </section>
  )
}

export default FAQs
